import { render, staticRenderFns } from "./QuestionConfig.vue?vue&type=template&id=27625734&scoped=true"
import script from "./QuestionConfig.vue?vue&type=script&lang=js"
export * from "./QuestionConfig.vue?vue&type=script&lang=js"
import style0 from "./QuestionConfig.vue?vue&type=style&index=0&id=27625734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27625734",
  null
  
)

export default component.exports